import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=0ae671a4&scoped=true&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"
import style0 from "./Success.vue?vue&type=style&index=0&id=0ae671a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae671a4",
  null
  
)

export default component.exports